import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { StaticComponentType } from '../interfaces/base-modal-content.interface';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private readonly dialog: MatDialog) {}

  public close(): void {
    this.dialog.closeAll();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public openOverlayWithConfig<C extends StaticComponentType<any>>(
    component: C,
    data?: C['overlayDataType']
  ) {
    this.dialog.open(component, {
      position: { right: '0px', left: '0px', bottom: '0px' },
      data,
      enterAnimationDuration: '0ms',
      backdropClass: 'userActivationDialog',
      disableClose: true,
    });
  }
}
